import { Navigate } from 'react-router-dom';
import { useAuth } from '~/hooks/useAuth';
import ProtectedRoute from './ProtectedRoute';

type Props = { children: JSX.Element };

/**
 * Solo para el superadministrador de Sontickets.
 *
 * La zona `/admin` únicamente comprobaba que hubiera sesión, así que **cualquier
 * administrador de un cliente podía entrar** y ver los negocios, las
 * ubicaciones, los usuarios y los registros de todos los demás. Comprobado con
 * la cuenta de NOI el 2026-09-10.
 *
 * El rol se comprueba por su NOMBRE, nunca por un correo ni por un id escrito a
 * mano: los identificadores no coinciden entre dev y producción.
 */
const SuperAdminRoute = ({ children }: Props) => {
  const { user } = useAuth();

  return (
    <ProtectedRoute>
      {user?.userRole?.name === 'superadmin' ? children : <Navigate to='/reservas' replace />}
    </ProtectedRoute>
  );
};

export default SuperAdminRoute;
